import { useRef, useState } from "react";
import { api, resolveSrc } from "@/api";
import { toast } from "sonner";
import { Upload, Loader2, X } from "lucide-react";

const UploadField = ({ label, value, onChange, testid }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.path);
      toast.success("Image envoyée");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Envoi impossible");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <p className="text-xs uppercase tracking-[0.25em] text-taupe">{label}</p>
      <input ref={inputRef} type="file" accept="image/*" hidden data-testid={`${testid}-input`} onChange={pick} />
      {value ? (
        <div className="relative mt-3">
          <img src={resolveSrc(value)} alt={label} className="aspect-[4/3] w-full object-cover" />
          <button
            type="button"
            onClick={() => onChange("")}
            data-testid={`${testid}-remove`}
            className="absolute right-2 top-2 rounded-full bg-ink/80 p-1.5 text-cream hover:bg-clay"
            aria-label={`Retirer ${label}`}
          >
            <X size={14} />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          data-testid={`${testid}-button`}
          className="mt-3 flex w-full items-center justify-center gap-2 border border-dashed border-bark/40 px-4 py-6 text-sm text-bark transition-colors duration-300 hover:border-clay hover:text-clay disabled:opacity-60"
        >
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} />}
          Choisir une image
        </button>
      )}
    </div>
  );
};

export default UploadField;
